import { apiSlice } from "../../app/api/apiSlice";

export const studentApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    tagTypes: ["Students", "Student"],
    importStudents: builder.mutation({
      query: (payload) => ({
        url: "/student/list",
        method: 'POST',
        body: { ...payload },
      }),
      invalidatesTags: ['Student', 'Students'],
    })
  }),
  overrideExisting: true,
})

export const {
  useImportStudentsMutation,
} = studentApiSlice